<template> 
    <a v-if="showButton" @click="this.createSession()" class="btn btn-primary mb-2">Vincular Tarjeta</a>  
</template>
<script>
import axios from "axios";
export default { 
    name: "cardFormSt",
    components: { 
    },
    data(){
        return{
            errorText: '',
            sessionSt: '',
            showButton: false,
        }
    },
    mounted: function () {
        const plugin = document.createElement("script");
        plugin.setAttribute("src", "https://js.stripe.com/v3/");
        plugin.async = false;
        document.head.appendChild(plugin);
        plugin.onload = () => {  
            this.showButton = true;
           // this.createSession();     
        }
    },
    methods:{ 
        async createSession(){
            //creamos la sesion / token para luego redirigir al checkout
            var payload = {
                action: 'link-plan-suscription-st',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: localStorage.getItem('token'),
                back: window.location.href,   
            }
            await axios.post('/index.php', payload).then(result => { 
                console.log(result)
                this.sessionSt = result.data.link;
                this.createLink();

            })
            .catch(error => {
               
            })     

        },

        async createLink(){       
            var stripe;

            if(window.location.host == 'animasana.net'){
                stripe = Stripe('pk_live_51HrMbmKt6OeeEi8zSAjZFGJhQHty85OFalFAWQb4CyD1wP6cm1ii0I6tO7W01ZgrOIn6tzmVkeno535Wm3iqwbYz00trXNNCz8');
            }else{
                stripe = Stripe('pk_test_51HrMbmKt6OeeEi8zjHoMjBHBczO1vmfa5x6Odr6V0FDNxXAVwxNNLmxlO4huXLHoZkXuDYZihsbRAiDZMQtXrz9j005MEPQ1ce');
            }
            var session = this.sessionSt;
            stripe.redirectToCheckout({ sessionId: session })
            .then(function(result) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, you should display the localized error message to your
                // customer using `error.message`.
                if (result.error) {
                    alert(result.error.message);
                }
            })
            .catch(function(error) {
                console.error('Error:', error);
            });          

        }

    }
}
</script>
